export interface AccidentModel {
  driverId: string;
  mistakes: number;
  violations: number;
  sos: number;
  date: Date;
}
